/**
 * ob-banner-slider.js
 * Vanilla JavaScript Slider for Shopify Horizon
 */

if (!customElements.get('ob-banner-slider')) {
  class ObBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.ob-slider__track');
      this.slides = Array.from(this.querySelectorAll('.ob-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.ob-slider__dot'));
      this.prevButton = this.querySelector('.ob-slider__arrow--prev');
      this.nextButton = this.querySelector('.ob-slider__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval) * 1000 || 5000;
      this.currentIndex = 1;
      this.timer = null;
      this.isTransitioning = false;
      
      // Drag & Swipe properties
      this.isDragging = false;
      this.startPos = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;

      this.init();
    }

    createClones(){
        const firstClone = this.slides[0].cloneNode(true);
        const lastClone  = this.slides[this.slides.length-1].cloneNode(true);
        firstClone.classList.add('ob-slider__clone');
        lastClone.classList.add('ob-slider__clone');
        this.track.prepend(lastClone);
        this.track.append(firstClone);
        this.slides = Array.from(this.querySelectorAll('.ob-slider__slide'));
        }

    init() {
    if(this.slides.length > 1){
    this.createClones();
    }
    this.updateSlides(false);
    this.addEventListeners();
    this.goToSlide(this.currentIndex,false);
    if(this.autoplay){
    this.startAutoplay();
    }
    }

    addEventListeners() {
      // Mouse events
      this.addEventListener('mousedown', (e) => this.dragStart(e));
      this.addEventListener('mouseup', () => this.dragEnd());
      this.addEventListener('mouseleave', () => this.dragEnd());
      this.addEventListener('mousemove', (e) => this.dragAction(e));

      // Touch events
      this.addEventListener('touchstart', (e) => this.dragStart(e), { passive: true });
      this.addEventListener('touchend', () => this.dragEnd());
      this.addEventListener('touchmove', (e) => this.dragAction(e), { passive: true });

      // Pause on hover
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });

      // Shopify Theme Editor support
      document.addEventListener('shopify:section:select', (e) => {
        if (e.target.contains(this)) this.stopAutoplay();
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.target.contains(this) && this.autoplay) this.startAutoplay();
      });

        this.dots.forEach((dot,index)=>{
        dot.addEventListener('click',()=>{
        this.stopAutoplay();
        this.goToSlide(index);

        if(this.autoplay){
        this.startAutoplay();
        }
        });
        });

        this.track.addEventListener('transitionend',()=>{

        this.track.style.transition='none';

        if(this.currentIndex===0){
        this.currentIndex=this.slides.length-2;
        this.setTrackPosition(-this.currentIndex*100);
        this.currentTranslate = -this.currentIndex * 100;
        this.prevTranslate = this.currentTranslate;
    }

        if(this.currentIndex===this.slides.length-1){
        this.currentIndex=1;
        this.setTrackPosition(-this.currentIndex*100);
        this.currentTranslate = -this.currentIndex * 100;
        this.prevTranslate = this.currentTranslate;

    }

    requestAnimationFrame(()=>{

        this.track.offsetHeight;

        this.track.style.transition='transform .5s ease-in-out';

    });

    });

    document.addEventListener('visibilitychange', () => {

    if (document.hidden) {

        this.stopAutoplay();
        return;

    }

    this.track.style.transition = 'none';

    this.setTrackPosition(-this.currentIndex * 100);

    this.currentTranslate = -this.currentIndex * 100;
    this.prevTranslate = this.currentTranslate;

    requestAnimationFrame(() => {

        this.track.offsetHeight;

        this.track.style.transition = 'transform .45s ease';

        if (this.autoplay) {
            this.startAutoplay();
        }

    });

});

/*==============================================================
ARROWS
==============================================================*/

if(this.prevButton){

    this.prevButton.addEventListener('click',()=>{

        this.stopAutoplay();

        this.goToSlide(this.currentIndex-1);

        if(this.autoplay){
            this.startAutoplay();
        }

    });

}

if(this.nextButton){

    this.nextButton.addEventListener('click',()=>{

        this.stopAutoplay();

        this.goToSlide(this.currentIndex+1);

        if(this.autoplay){
            this.startAutoplay();
        }

    });

}

this.addEventListener('keydown',(event)=>{

    if(event.key==="ArrowLeft"){

        this.prevButton?.click();

    }

    if(event.key==="ArrowRight"){

        this.nextButton?.click();

    }

});

    }

    dragStart(e) {
      this.isDragging = true;
      this.startPos = this.getPositionX(e);
      this.classList.add('ob-slider--dragging');
      this.stopAutoplay();
      this.track.style.transition = 'none';
    }

    dragAction(e) {
      if (!this.isDragging) return;
      const currentPosition = this.getPositionX(e);
      const diff = currentPosition - this.startPos;
      const percentage = (diff / this.offsetWidth) * 100;

this.currentTranslate = (-this.currentIndex * 100) + percentage;

this.track.style.transform =
`translate3d(${this.currentTranslate}%,0,0)`;
    }

    dragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.classList.remove('ob-slider--dragging');
      this.track.style.transition = 'transform .45s ease';
      
      const movedBy = (this.prevTranslate - this.currentTranslate);
      
      if (movedBy > 10){
        this.goToSlide(this.currentIndex + 1);
        }
        else if(movedBy < -10){
        this.goToSlide(this.currentIndex - 1);
        }
        else{
        this.goToSlide(this.currentIndex);
        }

      if (this.autoplay) this.startAutoplay();
    }

    getPositionX(e) {
      return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    }

    setTrackPosition(percent) {
      this.track.style.transform = `translateX(${percent}%)`;
      this.currentTranslate = percent;
    }

    goToSlide(index, animate = true) {
     this.currentIndex = index;
    this.track.style.transition = animate
    ? 'transform .5s ease-in-out'
    : 'none';
    this.setTrackPosition(-this.currentIndex * 100);
    this.prevTranslate = this.currentTranslate;
    this.updateSlides();
    }

   updateSlides() {
        let realIndex = this.currentIndex - 1;
        if (realIndex < 0) {
        realIndex = this.slides.length - 3;
        }

        if (realIndex > this.slides.length - 3) {
        realIndex = 0;
        }
        this.slides.forEach((slide,index)=>{
        slide.classList.toggle('is-active', index === this.currentIndex);
        });

        this.dots.forEach((dot,index)=>{
        dot.classList.toggle('is-active',index=== realIndex);
        dot.setAttribute(
      'aria-current',
      index=== realIndex ? 'true' : 'false'
        );
        });
    }

    startAutoplay() {
        this.stopAutoplay();
        this.timer = setInterval(()=>{
        this.goToSlide(this.currentIndex + 1);
        },this.interval);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  customElements.define('ob-banner-slider', ObBannerSlider);
}
